import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=0f4d4360&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=0f4d4360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d4360",
  null
  
)

export default component.exports